import { getCookie } from 'cookie-utils'

import * as GamesActions from '../../actions/games/index'
import * as AuthAction from '../../actions/auth/SignoutAction.js'
import { getLanguageType } from 'constants/Language'
import { isStage, isRingo } from '../../shared/domainUtils.js'

const initialState = {
  vivo: {},
  tvbet: {
    error: null,
    loading: false
  },
  virtual: {},
  xpressGames: {
    games: [],
    count: 0,
    loading: false,
  },
  xpressGamesUrlError: {
    Code: null,
    Data: null,
    Loading: false,
  },
  xpressGamesFilter: {
    providers: null,
    types: null,
  },
  pinnedXpressGames: {
    pinnedGames: [],
    count: 0,
    loading: false,
  },
}

const TVBET_CLIENT_ID = isStage ? 5631 : 5742

const TVBET_DEMO_CLIENT_ID = 5730
const TVBET_ROULLETTE_DEMO_ID = 6299

export default function gamesReducer(state = initialState, action = {}) {
  try {
    const lang = getLanguageType(Number(getCookie('languageId'))).name
    switch (action.type) {
      case GamesActions.SUCCESS_FETCH_VIVO_GAMES_TOKEN:
        return {
          ...state,
          vivo: action.data,
        }
      case GamesActions.FETCH_TVBET_GAMES_TOKEN:
        return {
          ...state,
          tvbet: {
            loading: true,
            error: null,
          },
        }
      case GamesActions.FAILURE_FETCH_TVBET_GAMES_TOKEN:
        return {
          ...state,
          tvbet: {
            error: action.data,
            loading: false,
          },
        }
      case GamesActions.SUCCESS_FETCH_TVBET_GAMES_TOKEN:
        if (action.data.token) {
          window.location.assign(
            `https://tvbetframe10.com/?lng=${lang}&clientId=${TVBET_CLIENT_ID}&token=${action.data.token}#/lobby`
          )
          return {
            ...state,
            tvbet: {
              loading: false,
              error: null,
            },
          }
        } else {
          return {
            ...state,
            tvbet: {
              error: action.data,
              loading: false,
            },
          }
        }
      case GamesActions.FETCH_TVBET_DEMO_GAMES:
        window.location.assign(
          `https://tvbetframe10.com/?lng=${lang}&clientId=${TVBET_DEMO_CLIENT_ID}&token=TvBet-DemoSite-User-BET#/lobby`
        )
        return state
      case GamesActions.FETCH_TVBET_ROULLETTE_DEMO:
        window.location.assign(
          `https://frame.elcasinoplay.com/?lng=${lang}&category=ElCasino&clientId=${TVBET_ROULLETTE_DEMO_ID}&token=EC-DemoSite-User-BET#/el-casino/22`
        )
        return state
      case GamesActions.FETCH_FASTSPORT_GAMES_TOKEN: {
        return {
          ...state,
          tvbet: {
            loading: true,
            error: null,
          },
        }
      }
      case GamesActions.FAILURE_FETCH_FASTSPORT_GAMES_TOKEN: {
        return {
          ...state,
          tvbet: {
            error: action.data,
            loading: false,
          },
        }
      }
      case GamesActions.SUCCESS_FETCH_FASTSPORT_GAMES_TOKEN:
        if (action.data.token) {
          const clientId = isRingo ? (isStage ? 8057 : 8048) : TVBET_CLIENT_ID
          window.location.assign(
            `https://frame.fastsport.bet/?lng=${lang}&clientId=${clientId}&token=${action.data.token}`
          )
          return {
            ...state,
            tvbet: {
              loading: false,
              error: null,
            },
          }
        } else {
          return {
            ...state,
            tvbet: {
              error: action.data,
              loading: false,
            },
          }
        }
      case GamesActions.SUCCESS_FETCH_TVBET_ROULLETTE_TOKEN:
        if (action.data.token) {
          window.location.assign(
            `https://tvbetframe10.com/?lng=${lang}&clientId=5742&token=${action.data.token}#/live-casino/22`
          )
        } else {
          return {
            ...state,
            tvbet: {
              error: action.data,
            },
          }
        }
        return state
      case GamesActions.SUCCESS_FETCH_VIRTUAL_SPORTS_GAMES_TOKEN:
        return {
          ...state,
          virtual: action.data,
        }

      case GamesActions.FETCH_XPRESS_GAMES:
        return {
          ...state,
          xpressGames: {
            ...state.xpressGames,
            loading: true,
          },
        }

      case GamesActions.SUCCESS_FETCH_XPRESS_GAMES:
        if (action.data.Code === 0) {
          return {
            ...state,
            xpressGames: {
              games: action.data.Data.Games,
              count: action.data.Data.Count,
              loading: false,
            },
          }
        } else if (action.data.Code !== 0) {
          return {
            ...state,
            xpressGamesUrlError: {
              Code: action.data.Code,
              Data: action.data.Data,
              Loading: false,
            },
          }
        }
        return state

      case GamesActions.FETCH_XPRESS_TOKEN:
        return {
          ...state,
          xpressGamesUrlError: {
            Code: null,
            Data: null,
            Loading: true,
          },
        }

      case GamesActions.SUCCESS_FETCH_XPRESS_TOKEN:
        if (action.data.Code === 0) {
          window.location.assign(action.data.Data.GameUrl)
        } else {
          return {
            ...state,
            xpressGamesUrlError: {
              Code: action.data.Code,
              Data: action.data.Data,
              Loading: false,
            },
          }
        }
        return state

      case GamesActions.FAILURE_FETCH_XPRESS_TOKEN:
        return {
          ...state,
          xpressGamesUrlError: {
            Code: action.data.Code,
            Data: action.data.Data,
            Loading: false,
          },
        }

      case AuthAction.SUCCESS_SIGNOUT: {
        const { xpressGamesFilter } = state
        return { ...initialState, xpressGamesFilter }
      }

      case AuthAction.CLEAR_TV_BET_ERROR:
        return {
          ...state,
          tvbet: {
            error: null,
          },
        }
      case GamesActions.FETCH_PROVIDER_XPRESS_GAMES:
        return state
      case GamesActions.SUCCESS_FETCH_PROVIDER_XPRESS_GAMES:
        return {
          ...state,
          xpressGamesFilter: {
            ...state.xpressGamesFilter,
            providers: action.data.Data,
          },
        }
      case GamesActions.FAILURE_FETCH_PROVIDER_XPRESS_GAMES:
        return state

      case GamesActions.FETCH_TYPE_XPRESS_GAMES:
        return state
      case GamesActions.SUCCESS_FETCH_TYPE_XPRESS_GAMES:
        return {
          ...state,
          xpressGamesFilter: {
            ...state.xpressGamesFilter,
            types: action.data.Data,
          },
        }
      case GamesActions.FAILURE_FETCH_TYPE_XPRESS_GAMES:
        return state

      case GamesActions.FETCH_PINNED_XPRESS_GAMES:
        return {
          ...state,
          pinnedXpressGames: {
            ...state.pinnedXpressGames,
            pinnedLoading: true,
          },
        }

      case GamesActions.SUCCESS_FETCH_PINNED_XPRESS_GAMES:
        if (action.data.Code === 0) {
          return {
            ...state,
            pinnedXpressGames: {
              pinnedGames: action.data.Data.Games,
              count: action.data.Data.Count,
              pinnedLoading: false,
            },
          }
        } else if (action.data.Code !== 0) {
          return {
            ...state,
            pinnedXpressGames: {
              Code: action.data.Code,
            },
          }
        }
        return state
      case GamesActions.UPDATE_XPRESS_PINNED_GAMES: {
        const { gameId, isPinned } = action.data
        const updatedGames = state.xpressGames.games.map((game) => {
          if (game.Id === gameId) {
            return {
              ...game,
              IsPinned: !isPinned,
            }
          } else {
            return game
          }
        })
        const updatedPinnedGames = state.pinnedXpressGames.pinnedGames.filter((game) => game.Id !== gameId && isPinned)
        return {
          ...state,
          xpressGames: {
            ...state.xpressGames,
            games: updatedGames,
          },
          pinnedXpressGames: {
            ...state.pinnedXpressGames,
            pinnedGames: updatedPinnedGames,
          },
        }
      }
    }
    return state;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('gamesReducer', error)
    return state
  }
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/gamesReducer.js